/**
 * Remove accents from a string.
 * @param value The string to remove accents from.
 * @returns The string without accents.
 * @example removeAccents('é') // 'e'
 */
export function removeAccents(value: string): string {
  // Normalize the string into Unicode NFD form and remove all diacritic marks.
  return value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
